import withConfigTransport from '../../services/config-transport/withConfigTransport'

import VaColorIndicatorComponent from './VaColorIndicator.vue'

const VaColorIndicator = withConfigTransport(VaColorIndicatorComponent)
export default VaColorIndicator
